import { useState } from "react";

interface RotatingModuleProps {
  modules: React.ComponentType<{ className?: string }>[];
  className?: string;
}

export function RotatingModule({ modules, className }: RotatingModuleProps) {
  const [Selected] = useState(() => {
    if (modules.length === 0) return null;
    return modules[Math.floor(Math.random() * modules.length)];
  });

  if (!Selected) return null;
  return <Selected className={className} />;
}
